import { useState } from "react";
import Head from "next/head";
import useKarir from "../../service/useKarir";
import FormText from "../../components/profile/FormText";
import Loading from "../../components/Loading";
import "react-quill/dist/quill.snow.css";
import dynamic from "next/dynamic";

const ReactQuill = dynamic(() => import("react-quill"), { ssr: false });
const edu_select = ["SMA", "D3", "S1", "S2", "S3"];
const gender_select = [
  { text: "Laki-laki", value: 0 },
  { text: "Perempuan", value: 1 },
];

export default function Karir() {
  const {
    data,
    fetching,
    value,
    form,
    setForm,
    handleChange,
    handleChangeEditor,
    submitForm,
    handleSubmit,
  } = useKarir();

  const [activeAccordion, setActiveAccordion] = useState(null);
  const CustomAccordion = ({ title, children, isOpen, onToggle }) => {
    return (
      <details
        open={isOpen}
        onClick={onToggle}
        className="cursor-pointer rounded-xl bg-white shadow-xl"
      >
        <summary
          className="flex items-center justify-between rounded-xl bg-[#F5B119] p-5 font-nunito text-lg font-bold text-[#142D59]"
          onClick={onToggle}
        >
          <p>{title}</p>
          <img
            src="/icon/dropdownBlue.svg"
            className={`h-4 w-4 ${
              isOpen
                ? "rotate-270 transform duration-200"
                : "-rotate-90 duration-200"
            }`}
          />
        </summary>
        {isOpen && <div>{children}</div>}
      </details>
    );
  };

  const handleToggle = (accordionIndex) => {
    setActiveAccordion(
      accordionIndex === activeAccordion ? null : accordionIndex
    );
  };

  return (
    <>
      <div className="w-full bg-[#F3F7FA]">
        <Head>
          <title>Karir | Wardaya Online by Wardaya College</title>
          <meta name="keywords" content="Karir, Wardaya College" />
        </Head>
        <div className="flex w-full flex-col space-y-4 pt-24 md:pt-28">
          <div className="h-[27.5rem] w-full bg-[url('/images/karir.png')] bg-cover bg-top py-5"></div>
        </div>
      </div>

      <div className="w-full bg-[#F3F7FA] py-6">
        <div className="mx-auto max-w-[1260px]">
          <p className="text-center font-nunito text-[40px] font-bold text-[#142D59]">
            Lowongan Pekerjaan
          </p>
          <div id="lowongan" className="flex flex-col gap-7 py-5 pb-28 ">
            {data.map((item, i) => (
              <CustomAccordion
                key={i}
                title={item.title}
                isOpen={activeAccordion === i}
                onToggle={() => handleToggle(i)}
              >
                <div className="flex flex-col gap-5 p-5">
                  <div className="flex flex-col gap-1">
                    <p className="text-base font-semibold text-[#142D59]">
                      Deskripsi Pekerjaan
                    </p>
                    <div
                      dangerouslySetInnerHTML={{ __html: item?.description }}
                    ></div>
                  </div>
                  <div className="flex flex-col gap-1">
                    <p className="text-base font-semibold text-[#142D59]">
                      Requirements
                    </p>
                    <div
                      dangerouslySetInnerHTML={{ __html: item?.requirements }}
                    ></div>
                  </div>
                  <div className="flex flex-col gap-1">
                    <p className="text-base font-semibold text-[#142D59]">
                      Benefits
                    </p>
                    <div
                      dangerouslySetInnerHTML={{ __html: item?.benefits }}
                    ></div>
                  </div>
                </div>
              </CustomAccordion>
            ))}
          </div>

          <div className="">
            <p className="text-center font-nunito text-[40px] font-bold text-[#142D59]">
              Formulir
            </p>
            <form
              className="grid grid-cols-1 gap-5 lg:grid-cols-2"
              onSubmit={(e) => handleSubmit(e, form, value)}
            >
              <FormText
                label={"Nama Lengkap"}
                name={"full_name"}
                type={"text"}
                value={form.full_name}
                handleChange={handleChange}
              />
              <FormText
                label={"Email"}
                name={"email"}
                type={"text"}
                value={form.email}
                handleChange={handleChange}
              />
              <FormText
                label={"Nomor Telepon"}
                handleChange={handleChange}
                value={form.phone}
                name={"phone"}
                type={"tel"}
              />
              <FormText
                label={"Tanggal Lahir"}
                name={"date_of_birth"}
                type={"date"}
                value={form.date_of_birth}
                handleChange={handleChange}
              />
              <div className="flex w-full flex-col">
                <label>Jenis Kelamin</label>
                <div className="flex items-center ">
                  <select
                    value={form.gender}
                    name="gender"
                    onChange={handleChange}
                    className="w-full rounded-md border border-[#ccc] py-2 px-2 font-medium placeholder:text-[#838383] focus:outline-gray-900"
                  >
                    <option hidden={true}>Pilih</option>
                    {gender_select.map((item, i) => (
                      <option key={i} value={item.value}>
                        {item.text}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="flex w-full flex-col">
                <label>Pendidikan</label>
                <div className="flex items-center ">
                  <select
                    value={form.education}
                    name="education"
                    onChange={handleChange}
                    className="w-full rounded-md border border-[#ccc] py-2 px-2 font-medium placeholder:text-[#838383] focus:outline-gray-900"
                  >
                    <option hidden={true}>Pilih</option>
                    {edu_select.map((item, i) => (
                      <option key={i} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <FormText
                label={"Universitas"}
                name={"university"}
                type={"text"}
                value={form.university}
                handleChange={handleChange}
              />
              <FormText
                label={"Jurusan"}
                name={"major"}
                type={"text"}
                value={form.major}
                handleChange={handleChange}
              />
              <FormText
                label={"Tahun Kelulusan"}
                name={"graduation_year"}
                type={"text"}
                value={form.graduation_year}
                handleChange={handleChange}
              />
              <FormText
                label={"IPK"}
                name={"gpa"}
                type={"number"}
                value={form.gpa}
                handleChange={handleChange}
              />
              <div className="col-span-2 flex w-full flex-col">
                <label>Posisi yang dilamar</label>
                <div className="flex items-center ">
                  <select
                    value={form.cms_career_id}
                    name="cms_career_id"
                    onChange={handleChange}
                    className="w-full rounded-md border border-[#ccc] py-2 px-2 font-medium placeholder:text-[#838383] focus:outline-gray-900"
                  >
                    <option hidden={true}>Pilih</option>
                    {data.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <FormText
                label={"Link Portfolio"}
                name={"link"}
                type={"text"}
                value={form.link}
                handleChange={handleChange}
              />
              <div className="flex w-full flex-col gap-2">
                <label>CV / Resume</label>
                <input
                  type={"file"}
                  accept=".pdf"
                  name="file"
                  onChange={(e) => {
                    var reader = new FileReader();
                    reader.readAsDataURL(e.target.files[0]);
                    setForm((prev) => ({ ...prev, file: e.target.files[0] }));
                  }}
                />
              </div>
              <div className="col-span-2">
                <p>Cover Letter</p>
                <ReactQuill
                  value={value}
                  onChange={handleChangeEditor}
                  theme="snow"
                  placeholder="Tulis teks di sini..."
                  style={{ height: "250px", marginBottom: "3rem" }}
                  modules={{
                    toolbar: [
                      [{ header: [1, 2, 3, false] }],
                      ["bold", "italic", "underline", "strike", "blockquote"],
                      [{ align: [] }],
                      [{ list: "ordered" }, { list: "bullet" }],
                      ["link", "image"],
                      ["clean"],
                    ],
                  }}
                />
              </div>

              <button className="col-span-2 w-full rounded-xl bg-[#142D59] py-2 font-nunito text-lg font-bold text-white">
                Send
              </button>
            </form>
          </div>
        </div>
      </div>

      {fetching || submitForm ? (
        <div className="fixed top-0 left-0 z-[150] flex h-screen w-screen items-center justify-center bg-black bg-opacity-10">
          <Loading fillcolor={"#EA374C"} />
        </div>
      ) : null}
    </>
  );
}
